const requireAll = (context) => context.keys().map(context);

// import variables before molecules
require('./elements/variables/index.css');

// require any molecules that
// need to preserve ordering
require('@lib/sharedRootCss/sharedRoot.css');
require('./elements/atoms/Root/Root.css');
require('./elements/atoms/RichText/RichText.css');

// require the rest of the elements
requireAll(require.context('./elements/atoms/', true, /\.css$/));
requireAll(require.context('./elements/molecules/', true, /\.css$/));
requireAll(require.context('./elements/organisms/', true, /\.css$/));
requireAll(require.context('./elements/modifiers/', true, /\.css$/));
